<template>
    <div ref="swiperContainer">
        <slot></slot>
    </div>
</template>
<script type="text/ecmascript-6">
    import Swiper from 'swiper'
    export default {
        name: 'slide',
        props: {
            slideTime: {
                type: Number,
                default: 4000
            },
            autoplay: {
                type: Boolean,
                default: true
            }
        },
        mounted () {},
        methods: {
            initSlide () {
                if (!this.$refs.swiperContainer) {
                    return
                }
                if (this.autoplay) {
                    this.slide = new Swiper('.swiper-container', {
                        pagination: '.swiper-pagination',
                        paginationClickable: true,
                        loop: true,
                        centeredSlides: true,
                        autoplay: this.slideTime,
                        autoplayDisableOnInteraction: false
                    })
                } else {
                    this.slide = new Swiper('.swiper-container', {
                        pagination: '.swiper-pagination',
                        paginationClickable: true,
                        loop: true,
                        centeredSlides: true
                    })
                }
            }
        }
  }
</script>



// WEBPACK FOOTER //
// src/public/Slide.vue